import { Pipe, PipeTransform } from '@angular/core';

import { DiffItem } from '../../coaching-base/diff-decorator';
import { EntityType } from '../../coaching-base/general';

@Pipe({
    name: 'diffItemFilter',
})
export class DiffItemFilter implements PipeTransform {
    transform(items: DiffItem[], filter: EntityType): DiffItem[] {
        if (!items || !filter) {
            return items;
        }
        items = items.filter((item) => item.entityTypeId === filter);
        return items;
    }
}
